import { render, staticRenderFns } from "./PreparingCoursewareBook.vue?vue&type=template&id=12817276"
import script from "./PreparingCoursewareBook.vue?vue&type=script&lang=js"
export * from "./PreparingCoursewareBook.vue?vue&type=script&lang=js"
import style0 from "./PreparingCoursewareBook.vue?vue&type=style&index=0&id=12817276&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports